import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, { type EmblaCarouselType, type EmblaOptionsType } from 'embla-carousel'
import {TsDOM as q} from '@/scripts/core/TsDOM'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'

export class UgcSlider extends UcoastEl {
	static htmlSelector = 'ugc-slider'
	uniqueId: string
	emblaApi?: EmblaCarouselType
	constructor() {
		super()
		this.uniqueId = q.ra(this, 'data-unique-id')
	}

	override animateIn() {
		super.animateIn()
		void this.initializeSlider()
	}

	initializeSlider() {
		const OPTIONS: EmblaOptionsType = {
			slidesToScroll: 1,
			align: 'start',
			containScroll: 'keepSnaps',
			dragFree: true,
			duration: 20,
			dragThreshold: 20,
			loop: false,
		}

		const viewportNode = q.rs('.embla__viewport', this)
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
		])
		this.emblaApi = emblaApi
	}
}
